module.exports = __webpack_public_path__ + "img/MES1_Indice2.c8523af5.png";